import { animated, AnimatedComponent } from '@react-spring/web';
import React from 'react';

import { ThemeDefinition, useThemeDefinition } from '@tanium/react-theme-definition';

export interface CircleOwnProps {
  /**
   * A theme definition for the fill color to use for the circle.
   */
  fill: ThemeDefinition;
}

export type CircleProps = CircleOwnProps &
  Omit<React.ComponentPropsWithoutRef<AnimatedComponent<'circle'>>, keyof CircleOwnProps | 'css'>;

export const Circle = React.memo(({ fill: fillProp, ...circleProps }: CircleProps): JSX.Element => {
  const fill = useThemeDefinition(fillProp);

  return <animated.circle fill={fill} {...circleProps} />;
});
